// axiosConfig.ts (or whatever you want to call it)
import axios, { InternalAxiosRequestConfig, AxiosError } from 'axios';
import { store } from 'src/State/store';
import { showSessionExpiredToast } from './toastUtils';

// REQUEST Interceptor - Add BOTH AuthToken AND X-User-IP
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    config.headers = config.headers ?? {};

    // 1. Add AuthToken from cookie
    const token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('AuthToken='))
      ?.split('=')[1];

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 2. Add X-User-IP from Redux store
    const state = store.getState();
    const userIP = localStorage.getItem('UserIP') || state.authentication.userIP;

    if (userIP) {
      config.headers['X-User-IP'] = userIP;
      console.log('✅ Headers being sent:', {
        Authorization: config.headers.Authorization,
        'X-User-IP': config.headers['X-User-IP']
      });
    } else {
      console.warn('⚠️ userIP is missing from Redux state');
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE Interceptor - Handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      showSessionExpiredToast();
    }
    return Promise.reject(error);
  }
);

// Export the global axios instance
export default axios;